"use strict"
import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";
import UIPropTypes from '../PropTypes';

// this flag is used to check if the pa.js file has already been
// added to head tag or not.
let initScript = false;

function initAnalyticsScript() {

    if (initScript) {
         return;
    }

    initScript = true;

    const head = document.getElementsByTagName("head")[0];
    const paScript = document.createElement("script");

    paScript.async = true;
    paScript.type = "text/javascript";
    paScript.src = "//www.paypalobjects.com/pa/js/pa.js";

    head.appendChild(paScript);

}

const triggerTracking = (function () {
    let timeoutId;

    return function (requestTrackingData) {

        clearTimeout(timeoutId);

        if (window.PAYPAL && typeof window.PAYPAL.analytics !== 'undefined') {

            window.PAYPAL.core = window.PAYPAL.core || {};
            window.PAYPAL.core.pta = PAYPAL.analytics.setup({data:requestTrackingData.dataString, url:requestTrackingData.url});

        } else {

             timeoutId = setTimeout(triggerTracking.bind(null, requestTrackingData), 250);
        }
    };
}());

export default class AnalyticsTemplate extends Component {

    static contextTypes = {
        requestTracking: UIPropTypes.requestTracking
    };

    componentDidMount() {

        initAnalyticsScript();

        triggerTracking(this.context.requestTracking);

    };

    componentWillReceiveProps(props, context){
         triggerTracking(this.context.requestTracking);
    };

    render() {
       return null;
    };
}



/** WEBPACK FOOTER **
 ** ./src/templates/AnalyticsTemplate.jsx
 **/